import { FC } from 'react'

import MinimumBilling from '@provider/Parametrization/MinimumBilling'
import RevisionProvider from '@provider/Parametrization/RevisionProvider'
import SimilarProduct from '@provider/Parametrization/SimilarProduct'
import Supply from '@provider/Parametrization/SupplyProvider'

import ParametrizationConfigPurchaseProvider from './ConfigPurchaseParamProvider'
import ParametrizationConfigToleranciaProvider from './ConfigToleranciaParamProvider'
import ParametrizationCurveDepedentsCDProvider from './CurveDepedentsCDProvider'
import ParametrizationCurveExecutationProvider from './CurveExecutationProvider'
import ParametrizationCurveStoreProvider from './CurveStoreProvider'
import ParametrizationCurveWeightProvider from './CurveWeightProvider'
import ParametrizationIncrementSupplierProvider from './IncrementSupplier'
import ReabRouteProvider from './ReabRouteProvider'
import ReabTimelineProvider from './ReabTimelineProvider'
import ReabTypeVeichuleProvider from './ReabTypeVeichuleProvider'

const ParametrizationProviders: FC = ({ children }) => {
  return (
    <Supply>
      <ParametrizationCurveWeightProvider>
        <ParametrizationCurveDepedentsCDProvider>
          <ParametrizationCurveExecutationProvider>
            <MinimumBilling>
              <RevisionProvider>
                <ParametrizationIncrementSupplierProvider>
                  <ParametrizationCurveStoreProvider>
                    <ReabTypeVeichuleProvider>
                      <ReabTimelineProvider>
                        <ReabRouteProvider>
                          <ParametrizationConfigPurchaseProvider>
                            <ParametrizationConfigToleranciaProvider>
                              <SimilarProduct>{children}</SimilarProduct>
                            </ParametrizationConfigToleranciaProvider>
                          </ParametrizationConfigPurchaseProvider>
                        </ReabRouteProvider>
                      </ReabTimelineProvider>
                    </ReabTypeVeichuleProvider>
                  </ParametrizationCurveStoreProvider>
                </ParametrizationIncrementSupplierProvider>
              </RevisionProvider>
            </MinimumBilling>
          </ParametrizationCurveExecutationProvider>
        </ParametrizationCurveDepedentsCDProvider>
      </ParametrizationCurveWeightProvider>
    </Supply>
  )
}

export default ParametrizationProviders
